<template>
  <div>
      <b-button variant="msstreamblue" @click="showModal('replaceThisVideo')">
        {{$ml.get('replacevideo')}}
      </b-button>

<b-modal ref="replaceThisVideo" hide-footer hide-header>
    <b-form @submit.prevent="replaceVideo">
        <b-form-group id="vodUploadGroup"
                      label="File to upload:"
                      label-for="vodFile">
          <b-row v-cloak @drop.prevent="isDraghover = false; addFile($event)">
            <b-col cols="12"  :class="{draggable:true, draghover: isDraghover}"  @dragover.prevent="isDraghover = true" @dragenter.prevent="isDraghover = true" @dragleave.prevent="isDraghover = false" @dragend.prevent="isDraghover = false" >
              <b-row class="justify-content-center" v-if="files.length === 0">
                <b-col cols="6"><font-awesome-icon class="uploadlogo" icon="cloud-upload-alt"></font-awesome-icon></b-col>
              </b-row>
              <b-row class="justify-content-center" v-if="files.length === 0">
                <h6 class="uploadtext">Drag and drop files here or click the + button below</h6>
              </b-row>
              <b-row class="inputCard justify-content-center align-items-center" style="line-height=0px" v-for="(file2, fileIndex2) in files" v-bind:key="file2.filename"> 
                <font-awesome-icon class="filelogo" icon="film"></font-awesome-icon>
                <p style="padding: 0px 10px; margin:0px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"><strong>{{file2.name}}</strong></p>
                <p style="padding: 0px 10px; margin:0px; text-align:center; border-left: 0.2rem solid #2a5d77">Size: {{Math.round(file2.size / 1000000)}} MB</p>

                <b-button v-if="!uploadStarted" variant="emptyB" @click="removeFile(fileIndex2)" >
                  <font-awesome-icon style="color: red" :icon="['fas', 'trash']" />
                </b-button>
                <b-button v-if="uploadStarted && !file2.toCancel" variant="emptyB" @click="cancelUpload(fileIndex2)" >
                  <font-awesome-icon style="color: red" :icon="['fas', 'trash']" />
                </b-button>
                <b-col cols=12 ><p v-if="file2.isLoading && !file2.toCancel" style="text-align:center; padding-top:10px; color:#14BF98">Upload in progress...</p></b-col>
                <b-col cols=12 ><p v-if="file2.isLoadingEnd && !file2.toCancel" style="text-align:center; padding-top:10px; color:#2F90B0">Video uploaded.</p></b-col>
                <b-col cols=12 ><p v-if="file2.toCancel" style="text-align:center; padding-top:10px; color:red">Cancelling upload.</p></b-col>

                <b-progress style="width:100%" v-if="file2.isLoading || file2.isLoadingEnd">
                  <b-progress-bar :value="file2.loadingPercent" animated variant="primary">
                    {{file2.loadingPercent}}%
                  </b-progress-bar>
                </b-progress>
              </b-row>
              <b-row class="justify-content-center" v-if="!uploadStarted">
                <b-col cols="auto">
                  <label for="file-upload" class="custom-file-upload">
                    <div class="btn btn-darkblue" style="width: 50px; margin:10px; font-weight:bold">+</div>
                  </label>
                  <input id="file-upload" accept="video/*" @input="addFile($event)" type="file" style="display: none;"/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form-group>
        <b-row class="justify-content-around align-items-center">
          <b-col cols="auto">
            <b-button type="submit" variant="msstreamblue">
              Submit
            </b-button>
          </b-col>
          <b-col cols="auto">
            <b-button variant="quanteeclg" @click="hideModal('replaceThisVideo')">
              {{$ml.get('close')}}
            </b-button>
          </b-col>
        </b-row>
    </b-form>
</b-modal>


    <b-modal ref="successNewPicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('picture')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('pictureuploadsuccess')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('successNewPicture');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { BASE_URL } from "@/services/base-url";
import VideoService from "@/services/video.service";
let videoService = new VideoService();
export default {
  name: "ReplaceComponent",
  props: [
    "video"
  ],
  components: {

  },
  data: function () {
    return {
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      files: [],
      uploadStarted: false,
      isDraghover: false,
    };
  },
  mounted() {

  },
  computed: {
   
  },
  methods: {
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    replaceVideo() {
        videoService.putReplaceVideo(this.video.uuid, this.$auth.token())
        .then((videoResult) => {
          this.uploadFiles([{video: videoResult}]);
        }).catch(err => {
            console.log(err)
        })
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    cancelUpload(index)
    {
        this.files[index].toCancel = true;      
    },
    addFile(e) {
      let droppedFiles = (e.dataTransfer)? e.dataTransfer.files : e.target.files;
      if(!droppedFiles) return;
      this.files = [];
      ([...droppedFiles]).forEach(f => {
        if (f.type.match("video") || f.type.match("mxf")) {
          //La ligne en dessous ne fonctionne pas/plus
          if(this.files.findIndex(file => file.name === f.name) === -1 && this.files.length === 0)
          {
            f.toCancel = false;
            f.qualities = [];
            f.encoding = "encoding";
            this.files.push(f);
          }
            
        }

      });
    },
    uploadFiles(results) {
      var chunkSize = 5 * 1000000;
      this.uploadstarted = true;
      function slice(file, start, end) {
        var slice = file.mozSlice ? file.mozSlice :
                    file.webkitSlice ? file.webkitSlice :
                    file.slice ? file.slice : noop;
        
        return slice.bind(file)(start, end);
      }

      var uploadFile = (video, fileIndex) => {        
        let seconds_to_days_hours_mins_secs_str =function(seconds) { 
          var hours    = Math.floor(seconds / (60*60));
              seconds -= hours   * (60*60);
          var minutes  = Math.floor(seconds / (60));
              seconds -= minutes * (60);
          if (minutes < 10 && hours > 0) {
              minutes = "0" + minutes;
          }
          if ((minutes > 0 || hours > 0) && seconds < 10) {
              seconds = "0" + seconds;
          }
          
          return ((0<hours)?(hours+":"):"") + ((0<minutes || hours > 0)?(minutes+":"):"") +seconds+"s";
        }

        return new Promise((done, reject) => {
          self = this;
          self.files[fileIndex].isLoading = true;
          self.files[fileIndex].isLoadingEnd = false;
          self.files[fileIndex].isLoadingError = false;
          self.files[fileIndex].loadingPercent =  0;
          self.files[fileIndex].currentData =  0;
          self.files[fileIndex].currentChunk =  1;
          self.files[fileIndex].startDate =  new Date();
          self.files = self.files.splice(0, self.files.length);

          var sendNextData = function() {
            var start = self.files[fileIndex].currentData;
            var size = self.files[fileIndex].size;
            var end = start + chunkSize;
            var isEnd = false;
            
            if (size - end <= 0) {
              end = size;
              isEnd= true;
            }

            var data = slice(self.files[fileIndex], start, end);
            videoService.postChunk(video.video.uuid, self.files[fileIndex].currentChunk, data, video.video.title, isEnd, self.$auth.token()).then(() => {
              if (isEnd) {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingError = false;
                self.files[fileIndex].isLoadingEnd = true;
                self.files[fileIndex].loadingPercent =  100;
                videoService.putVideoById({uploadingPercent: 100, uploadingETA: '0s', lastUploadingFeedbackDate: new Date()}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                self.files = self.files.splice(0, self.files.length);
                
                done();
              } else {
                var start = self.files[fileIndex].currentData += chunkSize;
                self.files[fileIndex].currentChunk += 1
                self.files[fileIndex].loadingPercent =  Math.round(100 * self.files[fileIndex].currentData / self.files[fileIndex].size);

                let currentDate = new Date();
                let currentPercent = self.files[fileIndex].loadingPercent;
                let timeSpentMS = currentDate.getTime() - self.files[fileIndex].startDate.getTime();
                let estimatedEndDuration = Math.round(timeSpentMS * 100 / currentPercent);
                let estimatedEndDate = new Date(self.files[fileIndex].startDate.getTime() + estimatedEndDuration);
                let durationUntilEnd = seconds_to_days_hours_mins_secs_str(Math.round((estimatedEndDate.getTime() - currentDate.getTime()) / 1000))
                videoService.putVideoById({uploadingPercent: self.files[fileIndex].loadingPercent, uploadingETA: durationUntilEnd, lastUploadingFeedbackDate: currentDate}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                
                self.files = self.files.splice(0, self.files.length);
                
                if(!self.files[fileIndex].toCancel)
                  setTimeout(sendNextData, 1);
                else{
                  
                  self.files[fileIndex].isLoading = false;
                  self.files[fileIndex].isLoadingError = false;
                  self.files[fileIndex].isLoadingEnd = true;
                  done();
                }
              }

            }).catch((err) => {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingEnd = false;
                self.files[fileIndex].isLoadingError = true;
                self.files[fileIndex].loadingPercent =  0;
                self.files = self.files.splice(0, self.files.length);

                done()
            })
          }

          if(!self.files[fileIndex].toCancel)
            sendNextData();
          else{
                  self.files[fileIndex].isLoading = false;
                  self.files[fileIndex].isLoadingError = false;
                  self.files[fileIndex].isLoadingEnd = true;
                  done();     
          }
        })
      }
      var video = results[0];
      var fileIndex = 0;

      uploadFile(video, fileIndex).then(() => {
        results.shift();
        if(this.files[fileIndex].toCancel)
        {
          this.removeFile(fileIndex)
                  videoService.deleteVideoById(video.video.uuid, this.$auth.token())
                  .then(()=>{
                  }).catch(err=>
                  {
                    console.log(err);
                  })             
        }
        if (results.length > 0) {
          this.uploadFiles(results);
        } else {
          this.files = [];
          this.uploadStarted = false;
          
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    

  },
};
</script>
<style scoped lang="scss">

.unselectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px, rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#14BF98, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice2 {
  text-align: center;
  min-height: 120px;
  font-weight: 400;
  font-size: 1.1rem;
  color:#2a5d77;
  cursor: pointer;
  margin: 10px;
  padding: 5px;
}

.commonChoice3 {
  text-align: center;
  min-height: 70px;
  font-weight: 400;
  font-size: 1.1rem;
  color:#2a5d77;
  cursor: pointer;
  margin: 2px;
  padding: 2px;
}

.unselectedChoice {
  border: 4px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px, rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice {
  border: 4px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#ba0000, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice {
  text-align: center;
  min-height: 60px;
  font-weight: 500;
  font-size: 2rem;
  color:black;
  cursor: pointer;
}

.uploadtext {
  color: rgba(#2a5d77, 1);
  font-style: italic;
  padding: 10px;
  margin: 10px;
  text-align:center;
}

.uploadlogo {
  margin-top: 30px;
  height: 100px; 
  width:100%; 
  color: rgba(#2a5d77, 0.8)
}

.removelogo {
  height: 20px; 
  width: 20px; 
}

.filelogo {
//  margin-top: 6px;
//  height: 100px; 
//  width:100%; 
  margin: 0px 10px;
  height: 30px; 
  width:5%; 
  color: rgba(#2a5d77, 0.8)
}

.draggable {
  min-height: 240px;
  outline: 2px dashed #2a5d77;
  outline-offset: -5px;
  box-shadow: rgba(black, 0.3) 1px 2px 7px, rgba(black, 0.3) 1px 2px 7px;
  background-color: rgba(#2F90B0, 0.03);
  //background-image: radial-gradient(circle at center, rgba(#19b952, 0.01), rgba(#19b952, 0.05));
}

.draggable.draghover {
  outline: 5px dashed #2a5d77;
  background-color: rgba(black, 0.03);
  //background-image: radial-gradient(circle at center, rgba(grey, 0.01), rgba(grey, 0.05)) !important;
}

.tag{
 font: 400 17px system-ui;
 overflow: hidden;
}
.tag input{
  border:none;
  outline:none;
}

.inputCard {
  transform: scale(0.9);
  outline: 3px double #2a5d77; //#ba0000;
  outline-offset: -3px;
  box-shadow: rgba(black, 0.3) 1px 2px 7px, rgba(black, 0.3) 1px 2px 7px;
  background-color: rgba(#2F90B0, 0.07);
  margin: 10px;
  padding: 10px;
  transition: .15s all ease-in-out;
  &:hover {
      box-shadow: rgba(black, 0.3) 1px 2px 7px, rgba(black, 0.3) 1px 2px 7px;
      transform: scale(0.91);
    }
  //background-image: radial-gradient(circle at center, rgba(#19b952, 0.1), rgba(#19b952, 0.2));
}














</style>
